// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__cBmin","itemTitle":"ClientEmergencyInfo_itemTitle__1osog","itemText":"ClientEmergencyInfo_itemText__3da9J"};